import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import MenuList from '@mui/material/MenuList/MenuList';
import React, { CanvasHTMLAttributes, Fragment, useEffect, useRef, useState } from 'react';
import { CanvasObject } from './canvas/CanvasObject';
import { Controller } from './canvas/Controller';
import { ILink } from './canvas/Link';
import { IBlock } from './canvas/temp';
import './RenderingEngine.css';

export interface IRenderingEngine extends CanvasHTMLAttributes<HTMLCanvasElement> {
}

const blocks: IBlock[] = [
  {
    id: 'block1',
    name: 'Block One',
    description: 'This is a block',
    children: ['block3']
  },
  {
    id: 'block2',
    name: 'Block Two',
    description: 'This is a block',
    children: []
  },
  {
    id: 'block3',
    name: 'Block Three',
    description: 'This is a block',
    children: []
  }
];

export default function RenderingEngineOld(props: IRenderingEngine) {
  let canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [link, setLink] = useState<null | ILink>(null);

  useEffect(() => {
    if (canvasRef.current) {
      let canvas: any = document.getElementById('canvas');
      let ctx: any = canvas.getContext('2d');

      const controller = new Controller(canvas, ctx, blocks, {
        onLink: (line: CanvasObject<ILink>) => {
          setLink(line.meta);
        }
      });

      const draw = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        // Translate to the canvas centre before zooming - so you'll always zoom on what you're looking directly at
        ctx.translate(window.innerWidth / 2, window.innerHeight / 2);
        ctx.scale(controller.cameraZoom, controller.cameraZoom);
        ctx.translate(
          -window.innerWidth / 2 + controller.cameraOffset.x,
          -window.innerHeight / 2 + controller.cameraOffset.y
        );
        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

        controller.update(canvas, ctx);

        requestAnimationFrame(draw);
      };

      draw();
    }
  }, [canvasRef.current]);

  return (
    <Fragment>
      <canvas id="canvas" {...props} ref={canvasRef}/>

      <Dialog
        maxWidth="xs"
        open={!!link}
        onClose={() => setLink(null)}
      >
        <DialogTitle>Link</DialogTitle>
        <DialogContent>
          <MenuList>
            <MenuItem>
              Remove
            </MenuItem>
          </MenuList>

        </DialogContent>
      </Dialog>
    </Fragment>
    );
}
